import type { ShapeManagerRef } from '@/lib/shapes/types/shape-manager-ref'

/** WMPCM-11088 — Escape step: deselect when a placed photo shape is selected on the canvas. */
export function clearCanvasPhotoSelectionIfAny(
  shapeManager: ShapeManagerRef | null | undefined
): boolean {
  if (typeof shapeManager?.getSelectedShapeIds !== 'function') return false
  if (typeof shapeManager?.getShapes !== 'function') return false
  if (typeof shapeManager?.clearSelection !== 'function') return false

  const selectedIds = shapeManager.getSelectedShapeIds()

  if (selectedIds.length === 0) return false

  const shapes = shapeManager.getShapes()
  const hasPhotoSelected = selectedIds.some((id) => {
    const shape = shapes.find((entry) => entry.id === id)

    return Boolean(shape?.photoFill)
  })

  if (!hasPhotoSelected) return false

  shapeManager.clearSelection()
  return true
}
